import type { FieldState } from "@/domains/buildings/types/buildingWidget";
import { isAllowedEnumValue } from "./enumValue";
import type { getEnumRule } from "./getEnumRule";

/**
 * Emptying the value is how a confirmed field is cleared: the inspector footer
 * hides Accept/Reject once a field is confirmed, so an empty draft has to be
 * savable there. It persists a blank string, which removes the user override
 * and reveals the machine findings again — the same semantics as `FieldRow`'s
 * clear (✗) control.
 *
 * Every control has to be able to reach an empty draft for that to mean
 * anything: the text input and the multi-select can, and the single-enum
 * `<Select>` gets an explicit "Clear value" item for a confirmed field.
 */
export function canSaveInspectorDraft(
  state: FieldState,
  normalizedDraft: string,
  enumRule: ReturnType<typeof getEnumRule>
): boolean {
  if (!normalizedDraft) return state === "confirmed";
  return isAllowedEnumValue(normalizedDraft, enumRule);
}
